'use client';

import { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import { BackendAuth } from '@/lib/auth-backend';

// Client wrapper so the heavy agent drawer can be code-split out of the
// (Server Component) root layout's synchronous compile. `ssr: false` is allowed
// here because this wrapper is itself a Client Component (it would error if used
// directly in the server root layout).
const XoffiAgentDrawer = dynamic(() => import('@/components/ai/xoffi-agent-drawer'), {
  ssr: false,
});

export default function XoffiAgentDrawerLazy() {
  // Pre-login gar nicht rendern, damit der Chunk auf /signin & Co. nie geladen
  // wird. Der einzige Öffnungs-Trigger (Header-Button, 'xoffi-agent:toggle')
  // existiert nur unter (protected); nach Login remountet der Wrapper durch den
  // Hard-Reload authentifiziert. Check erst im Effect (client-only, kein
  // Hydration-Mismatch).
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    // Nur fuer Mitarbeiter mit normalem Login – NIE fuer Lieferanten-/Link-Sessions
    // (KHG-Lieferant per Mail-Link sah den Agent-Chat, User 20.10.2026).
    const u = BackendAuth.getUser?.() || {};
    const linkSession = !!(u.khg_supplier || u.supplier || u.login_via_link || u.link_login);
    setAuthenticated(BackendAuth.isAuthenticated() && !linkSession);
  }, []);

  if (!authenticated) return null;

  return <XoffiAgentDrawer />;
}
